export const FREE = 'free'
export const TRIAL = 'trial'
export const COMPLETE = 'full'
export const FINANCIAL_OVERVIEW = 'financial_overview'
